export default __webpack_public_path__ + "static/0070-4cd85444061847610f0e2dbd5b0a66b8.png";